import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useApprovalSettingsUrl } from '../hooks/useApprovalSettingsUrl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AddTeamApproversFooter = () => {
  const settingsUrl = useApprovalSettingsUrl('approvers', {
    teamApprovers: true
  });
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    gap: 8,
    "data-test-id": "add-team-approvers-footer",
    children: [/*#__PURE__*/_jsx(Button, {
      use: "link",
      size: "small",
      href: settingsUrl,
      external: true,
      "data-test-id": "add-team-approvers-link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.approverSelect.footer.addTeamApprovers"
      })
    }), /*#__PURE__*/_jsx(Badge, {
      use: "new",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.approverSelect.footer.newTag"
      })
    })]
  });
};